import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, Validators, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-new-report-modal',
    templateUrl: './new-report-modal.component.html',
    styleUrls: ['./new-report-modal.component.scss'],
    standalone: false
})
export class NewReportModalComponent implements OnInit {

    form: FormGroup;
    submitted = false;

    report: any;

    constructor(public activeModal: NgbActiveModal, private fb: UntypedFormBuilder) { }

    ngOnInit() {
        this.form = this.fb.group({
            name: ['', Validators.required],
            view_name: ['', Validators.required],
            config: ['{}', [Validators.required, this.jsonValidator]]
        });

        if (this.report) {
            let config = this.report.config;
            if (typeof config === 'object') {
                config = JSON.stringify(config, null, 4);
            }
            this.form.patchValue({
                ...this.report,
                config: config
            });
        }

        this.form.get('config').valueChanges.subscribe(val => {
            try {
                const obj = JSON.parse(val);
                const formatted = JSON.stringify(obj, null, 4);
                if (val !== formatted) {
                    // check if they are semantically different or just whitespace diff to avoid annoying jumps
                    // actually, if we just formatted it, we don't want to re-trigger if the user is typing...
                    // but the requirement is "prettify the JSON input on change, when the input is valid JSON".
                    // If I type `{"a": 1` -> invalid. `{"a": 1}` -> valid -> auto-format.
                    // The issue is cursor position might be lost.
                    // For now, I'll do it.
                    this.form.get('config').setValue(formatted, { emitEvent: false });
                }
            } catch (e) {
                // ignore
            }
        });
    }

    get f() { return this.form.controls; }

    jsonValidator(control) {
        try {
            JSON.parse(control.value);
        } catch (e) {
            return { 'invalidJson': true };
        }
        return null;
    }

    submit() {
        this.submitted = true;
        if (this.form.invalid) {
            return;
        }

        this.activeModal.close(this.form.value);
    }

    close() {
        this.activeModal.dismiss();
    }

}
